import React from 'react';
import BackButton from '../components/BackButton';
import SyntheticProfiles from '../components/SyntheticProfiles';

function SyntheticProfilesPage() {
  return (
    <>
      <BackButton />
      <SyntheticProfiles />
    </>
  );
}

export default SyntheticProfilesPage;
